<template>
  <modal
    v-slot="{ data }"
    name="giftCardReceipt"
    modal-style="compact"
  >
    <gift-card-receipt
      :receipt="data.receipt"
      :override-receipt-navigation="data.overrideReceiptNavigation"
    />
  </modal>
</template>


<script>
  import GiftCardReceipt from './gift-card-receipt/index.vue';


  export default {
    name: 'GiftCardReceiptModal',

    components: {
      GiftCardReceipt
    }
  };
</script>
